import { render, staticRenderFns } from "./industry_manage.vue?vue&type=template&id=bd6a6464&scoped=true"
import script from "./industry_manage.vue?vue&type=script&lang=js"
export * from "./industry_manage.vue?vue&type=script&lang=js"
import style0 from "./industry_manage.vue?vue&type=style&index=0&id=bd6a6464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a6464",
  null
  
)

export default component.exports